import { Box, Flex, Heading, Icon, Text } from '@chakra-ui/react'
import { type ReactNode } from 'react'
import { type HomeIcon } from '@heroicons/react/24/outline'

interface Props {
  title: ReactNode
  description: ReactNode
  icon: typeof HomeIcon
  actions?: ReactNode
}

export default function PageHeader({
  title,
  description,
  icon,
  actions
}: Props) {
  return (
    <Flex justify="space-between" align="start" gap={4} wrap="wrap">
      <Box>
        <Flex align="center" gap={3} mb={2}>
          <Flex
            bg="white"
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius="xl"
            p={2}
            color="gray.600"
          >
            <Icon as={icon} boxSize={5} />
          </Flex>
          <Heading as="h1" size="lg" letterSpacing="-0.04em">
            {title}
          </Heading>
        </Flex>
        <Text color="gray.500" fontSize="sm" maxW="580px">
          {description}
        </Text>
      </Box>
      {actions && (
        <Flex gap={2} align="center" flexWrap="wrap">
          {actions}
        </Flex>
      )}
    </Flex>
  )
}
